export const noSpecialCharacters = (string: string) => {
  return /[^\p{L}\p{N}\p{P}\p{Z}\p{M}^$€<>=+¨~−\n]/gu.test(string)
}

export default function useRegex() {
  const isUrlValid = (string: string) => {
    const regex = new RegExp("^https?://(?:www\\.)?[\\w\\-\\.~:/?#[\\]@!$&'()*+,;=%]{1,2000}$")
    return regex.test(string)
  }

  const isAlphaNumeric = (string: string) => {
    const regex = new RegExp('^[a-zA-Z0-9]*$')
    return regex.test(string)
  }

  const isAlphaNumericWithSpace = (string: string) => {
    const regex = new RegExp('^[a-zA-Z0-9 ]*$')
    return regex.test(string)
  }

  const isEmailValid = (string: string) => {
    const regex = new RegExp('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')
    return regex.test(string)
  }

  const replacePlaceholder = (text: string, replacingText: string, placeholder: string) => {
    const regex = new RegExp(`{{\\s*${placeholder}\\s*}}`, 'g')
    return text.replace(regex, replacingText)
  }

  return {
    isAlphaNumeric,
    isAlphaNumericWithSpace,
    noSpecialCharacters,
    isUrlValid,
    isEmailValid,
    replacePlaceholder
  }
}
